var exports = {
  "jD": "x4ddf2309--3afc05--breadcrumbs",
  "Qs": "x4ddf2309--3afc05--content",
  "E": "x4ddf2309--3afc05--favorites",
  "Vg": "x4ddf2309--3afc05--grid",
  "fi": "x4ddf2309--3afc05--column",
  "Os": "x4ddf2309--3afc05--group",
  "x7": "x4ddf2309--3afc05--group-title",
  "nM": "x4ddf2309--3afc05--group-list",
  "nf": "x4ddf2309--3afc05--link",
  "Tc": "x4ddf2309--3afc05--tag",
  "qr": "x4ddf2309--3afc05--footer",
  "RC": "x4ddf2309--3afc05--preloader",
};

module.exports = exports;
